<div class="header">
  <div class="title">User Analytics</div>
</div>
<div id="user-analytics-content">
  <div class="analytics-section">
    <div class="grid-item planograms-created">
      <div style="text-align: left">
        <img src="../../assets/analytics_data.svg" alt="Star" />
        <span class="section-label"> Planograms Created </span>
      </div>
      <div class="section-data" *ngIf="planogram_data">
        {{ planogram_data.total_planogram_created }}/{{
          planogram_data.total_planogram_possible
        }}
      </div>
    </div>
    <div class="grid-item active-users">
      <div style="text-align: left">
        <img src="../../assets/analytics_data.svg" alt="Star" />
        <span class="section-label">Active Users</span>
      </div>
      <div class="section-data" *ngIf="user_active">
        {{ user_active.active_users }}/{{ user_active.total_users }}
      </div>
    </div>
    <div *ngIf="true" class="grid-item" id="admin-bottler-lists-container">
      <!-- <div class="table-title">
        <span>Table</span>
      </div> -->
      <div class="table-wrapper">
        <table
          id="bottlers-list-table"
          mat-table
          *ngIf="
            user_analytics_data_list && user_analytics_data_list.length > 0
          "
          [dataSource]="dataSource"
          class="my-table"
        >
          <ng-container matColumnDef="bottler">
            <th  mat-header-cell *matHeaderCellDef>
              <mat-form-field style="width:8vw" class="filter-dropdown">
                <mat-label>Bottler</mat-label>
                <mat-select
                  multiple
                  (selectionChange)="filterDataBasedOnFilterSelection()"
                  [(ngModel)]="selectedBottlers"
                  class="planogram-filter-select filter-select"
                >
                <mat-option>
                  <mat-checkbox
                    class="mat-accent"
                    [checked]="allBottlersSelected"
                    (change)="toggleAllOption('bottler')"
                    (click)="$event.stopPropagation()"
                    >All
                  </mat-checkbox></mat-option
                >
                  <mat-option
                    *ngFor="let bottler of bottlers"
                    [value]="bottler"
                  >
                    <mat-checkbox 
                    [checked]="selectedBottlers.includes(bottler)"
                    class="mat-accent"
                      >{{ bottler }}
                    </mat-checkbox></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let val">
              {{ val.bottler }}
            </td>
          </ng-container>

          <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field class="filter-dropdown">
                <mat-label>Unit</mat-label>
                <mat-select
                  multiple
                  [(ngModel)]="selectedUnits"
                  (selectionChange)="filterDataBasedOnFilterSelection()"
                  class="planogram-filter-select filter-select"
                >
                <mat-option>
                  <mat-checkbox
                    class="mat-accent"
                    [checked]="allUnitsSelected"
                    (change)="toggleAllOption('unit')"
                    (click)="$event.stopPropagation()"
                    >All
                  </mat-checkbox></mat-option
                >
                  <mat-option
                    *ngFor="let unit of units"
                    [value]="unit"
                  >
                    <mat-checkbox 
                    [checked]="selectedUnits.includes(unit)"
                    class="mat-accent"
                      >{{ unit }}
                    </mat-checkbox></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let val">
              {{ val.unit }}
            </td>
          </ng-container>

          <ng-container matColumnDef="channel">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field class="filter-dropdown">
                <mat-label>Channel</mat-label>
                <mat-select
                  multiple
                  (selectionChange)="filterDataBasedOnFilterSelection()"
                  [(ngModel)]="selectedChannels"
                  class="planogram-filter-select filter-select"
                >
                <mat-option>
                  <mat-checkbox
                    class="mat-accent"
                    [checked]="allChannelsSelected"
                    (change)="toggleAllOption('channel')"
                    (click)="$event.stopPropagation()"
                    >All
                  </mat-checkbox></mat-option
                >
                  <mat-option
                    *ngFor="let channel of channels"
                    [value]="channel"
                  >
                    <mat-checkbox 
                    [checked]="selectedChannels.includes(channel)"
                    class="mat-accent"
                      >{{ channel }}
                    </mat-checkbox></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let val">
              {{ val.channel }}
            </td>
          </ng-container>

          <ng-container matColumnDef="caser">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field class="filter-dropdown">
                <mat-label>Caser</mat-label>
                <mat-select
                  multiple
                  (selectionChange)="filterDataBasedOnFilterSelection()"
                  [(ngModel)]="selectedCasers"
                  class="planogram-filter-select filter-select"
                >
                <mat-option>
                  <mat-checkbox
                    class="mat-accent"
                    [checked]="allCasersSelected"
                    (change)="toggleAllOption('caser')"
                    (click)="$event.stopPropagation()"
                    >All
                  </mat-checkbox></mat-option
                >
                  <mat-option
                    *ngFor="let caser of casers"
                    [value]="caser"
                  >
                    <mat-checkbox 
                    [checked]="selectedCasers.includes(caser)"
                    class="mat-accent"
                      >{{ caser }}
                    </mat-checkbox></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let val">
              {{ val.caser }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field class="filter-dropdown">
                <mat-label>Planogram Status</mat-label>
                <mat-select
                (selectionChange)="filterDataBasedOnFilterSelection()"
                  multiple
                  [(ngModel)]="selectedPlanogramStatus"
                  class="planogram-filter-select filter-select"
                >
                <mat-option>
                  <mat-checkbox
                    class="mat-accent"
                    [checked]="allPlanogramStatusSelected"
                    (change)="toggleAllOption('planogram status')"
                    (click)="$event.stopPropagation()"
                    >All
                  </mat-checkbox></mat-option
                >
                  <mat-option
                    *ngFor="let status of planogram_status"
                    [value]="status"
                  >
                    <mat-checkbox 
                    [checked]="selectedPlanogramStatus.includes(status)"
                    class="mat-accent"
                      >{{ status }}
                    </mat-checkbox></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let val">
              <div
                style="width: 80%; margin: auto"
                [ngClass]="getStatusClass(val.status)"
              >
                {{ val.status }}
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div
          class="no-data-message"
          *ngIf="user_analytics_data_list.length == 0"
        >
          No data matching with the filter
        </div>
      </div>
    </div>
  </div>
  <div
    style="width: 100%; height: 100%; margin-top: 3%"
    class="user-analytics-QNA-section"
  >
    <div class="card">
      <div>
        <div style="margin-bottom: 3%">
          <div class="QNA-title">
            <div>Questions</div>
          </div>
          <!-- <span class="QNA-info-label"
            >Ergonomic executive chair upholstered in bonded black leather
            all-day comfort and support</span
          > -->
        </div>
        <div class="horizontal-line"></div>
        <div>
          <div *ngIf="user_query_data" class="user-QNA-cards">
            <ng-container *ngFor="let user of user_query_data; let i = index">
              <div class="-data-qna-list">
                <div class="user-lists">
                  <div class="user-analytics-qna-content">
                    <div
                      class="user-question-header"
                      (click)="toggleQNASection(i)"
                    >
                      <div
                        *ngIf="expandedUserIndex !== i"
                        style="display: flex; justify-content: space-between"
                      >
                        <span class="user-question">{{ user.subject }}</span>
                        <img
                          [src]="
                            expandedUserIndex === i
                              ? '../../assets/collapse.svg'
                              : '../../assets/expand.svg'
                          "
                          alt="Toggle"
                          style="cursor: pointer; height: 3.5vh"
                        />
                      </div>
                    </div>
                    <div
                      class="user-details-content"
                      *ngIf="expandedUserIndex === i"
                    >
                      <div class="user-icon-img">
                        <div style="display: flex">
                          <img src="../../assets/user_icon.svg" alt="User" />
                          <div style="margin-left: 10px; margin-top: 5px">
                            <div class="user-name">{{ user.username }}</div>
                            <div class="user-details">
                              {{ user.bottler }} |
                              {{ user.updated_at | date : "d MMMM yyyy" }}
                            </div>
                          </div>
                        </div>
                        <div
                          *ngIf="expandedUserIndex === i"
                          style="float: right; margin-top: 0px; cursor: pointer"
                          (click)="toggleQNASection(i)"
                        >
                          <img
                            style="height: 3.5vh"
                            [src]="
                              expandedUserIndex === i
                                ? '../../assets/collapse.svg'
                                : '../../assets/expand.svg'
                            "
                            alt="Toggle"
                          />
                        </div>
                      </div>
                      <div class="user-qna-info-section">
                        <div class="user-question-section">
                          {{ user.subject }}
                        </div>
                        <div class="user-answer-section">
                          {{ user.description }}
                        </div>
                        <div class="user-reply-section">
                          <div class="admin-input-to-reply">
                            <input
                              [(ngModel)]="reply"
                              type="text"
                              #replyInput
                              placeholder="Reply here"
                            />
                            <a
                              class="reply_button"
                              [href]="sendReply(user)"
                              target="_top"
                              >Reply</a
                            >
                          </div>
                          <div class="qna-resolved-status">
                            <ng-container
                              *ngIf="
                                user.resolved === 'Resolved';
                                else notResolved
                              "
                            >
                              <span class="resolved-icon">&#10003;</span>

                              <span>{{ user.resolved }}</span>
                            </ng-container>
                            <ng-template #notResolved>
                              <img
                                src="../../assets/not_resolved.svg"
                                alt="Resolved Status"
                              />
                              <span style="margin-right: 1vw">{{
                                user.resolved
                              }}</span>
                              <button
                                (click)="
                                  markResolve(user.query_id, user.user_id)
                                "
                              >
                                Mark as resolve
                              </button>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="i !== usersData.length - 1"
                  class="horizontal-line"
                ></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-loader
    [is_show_loader]="(loader | async)! || is_show_loader"
  ></app-loader>
</div>
